export const formatMultipleStatuses = (statuses: string[]) => {
  if (!Array.isArray(statuses)) {
    console.warn('⚠️ Statuts invalides reçus :', statuses)
    return 'unknown-status'
  }

  return statuses
    .map(status => {
      switch (status) {
        case 'libertins ou visiteur':
          return 'libertins-visiteurs'
        case 'private':
          return 'prive'
        case 'escort':
          return 'escort'
        case 'massage':
          return 'massage'
        case 'maison privee':
          return 'maison-privee'
        case 'bars et clubs prive':
          return 'bars-clubs-prives'
        case 'salons de massage':
          return 'salons-massage'
        case 'hotels coquins':
          return 'hotels-coquins'
        case 'saunas prives':
          return 'saunas-prives'
        case 'clubs echangistes':
          return 'clubs-echangistes'
        default:
          return status
      }
    })
    .join('-')
}

export const formatGender = (gender: string) => {
  switch (gender) {
    case 'woman':
      return 'femme'
    case 'man':
      return 'homme'
    case 'transgender':
      return 'transgenre'
    case 'couple':
      return 'couple'
    default:
      return gender
  }
}

export const formatURL = (title?: string, id?: number) => {
  if (!title || !id) {
    return 'unknown/0'
  }

  return `${title
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')}/${id}`
}
